module.exports = __webpack_public_path__ + "img/trueIcon.d9e97f36.png";